<template>
    <auth-layout
        :image="1"
        :byword="$t('pages.auth.signup.steps.register.byword')"
        :progress="progress"
        :isProgressBarHidden="true"
    >
        <common-content-wrapper width="small-medium">
            <common-content-spacer height="medium">
                <div class="icon__center">
                    <common-icon :name="icon" size="ultra-large"></common-icon>
                </div>

                <common-page-header :heading="heading">
                    <template #content>
                        {{ $t('pages.auth.signup.steps.practice.practice_missing.heading') }}
                    </template>
                </common-page-header>
            </common-content-spacer>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import { mapGetters } from 'vuex'
    import SignupPageMixin from 'mixins/SignupPageMixin'
    import AuthLayout from 'components/layouts/AuthLayout'

    export default {
        mixins: [SignupPageMixin],

        components: {
            AuthLayout,
        },

        computed: {
            ...mapGetters({
                getAdminNotAlreadyInvited: 'ui/getAdminNotAlreadyInvited',
            }),

            heading() {
                return this.getAdminNotAlreadyInvited
                    ? this.$t('pages.auth.signup.steps.practice.practice_missing.invite_sent')
                    : this.$t('pages.auth.signup.steps.practice.practice_missing.practice_not_registred')
            },

            icon() {
                return this.getAdminNotAlreadyInvited ? 'success' : 'error'
            },
        },

        mounted() {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = 'mobile'
        },

        beforeDestroy: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = ''
        },
    }
</script>
